export const FrenchFlag = ({ className = "w-4 h-3" }) => (
    <span className={`inline-flex ${className} border border-charcoal/15 shrink-0`} data-testid="french-flag" aria-label="France">
        <span className="flex-1 bg-[#0055A4]" />
        <span className="flex-1 bg-white" />
        <span className="flex-1 bg-[#EF4135]" />
    </span>
);
